import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbNameMap = {
    'devsecops': 'DevSecOps Career Path',
    'devex': 'Developer Experience Career Path',
    'cloud-platform-engineer': 'Cloud Platform Engineer Path',
    'devops-questionnaire': 'DevOps Career Path',
    'sre-questionnaire': 'SRE Career Path',
    'penetration-testing': 'Penetration Testing Career Path',
    'cybergrc': 'Cyber GRC Career Path',
    'product-manager': 'Product Manager Career Path',
    'ai-data-engineer': 'AI & Data Engineer Path',
    'security-analyst': 'Security Analyst Career Path',
    'full-stack-engineer': 'Full Stack Engineer Path'
  };

  return (
    <nav aria-label="breadcrumb" className="py-4 px-6">
      <ol className="flex space-x-2 text-slate-300">
        <li>
          <Link to="/" className="hover:text-green-400">Home</Link>
        </li>
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;

          return last ? (
            <li key={to} className="flex items-center">
              <span className="mx-2">/</span>
              <span className="text-green-400">{breadcrumbNameMap[value] || value}</span>
            </li>
          ) : (
            <li key={to} className="flex items-center">
              <span className="mx-2">/</span>
              <Link to={to} className="hover:text-green-400">
                {breadcrumbNameMap[value] || value}
              </Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;